import React, { useRef, useState } from 'react';

import { formatDateToShortDot } from '@repo/common';
import PreviewContent from '../../../../Career/Preview/PreviewContent';
import ResumeCardOptionList from '../../../../Career/Default/ResumeCardOptionList';

import { ReactComponent as OptionIcon } from '@repo/common/assets/icons/24px/icon_24px_more-vert.svg';
import { ReactComponent as MobileOptionIcon } from '@repo/common/assets/icons/20px/icon_20px_more-vert.svg';

const ResumeCard = ({
  resumeData,
  onClick,
  onDeleted,
  onStandardSuccess,
  onDeleteSuccess,
  $isMobile,
  isCareerPage,
}) => {
  const optionBtnRef = useRef(null);
  const [isOptionListOpen, setIsOptionListOpen] = useState(false);

  const toggleOptionList = (e) => {
    e.stopPropagation();
    setIsOptionListOpen((prev) => !prev);
  };

  const roles = (resumeData.profile?.targetRole ?? [])
    .flat()
    .map((r) => (typeof r === 'string' ? r.trim() : ''))
    .filter(Boolean);

  return (
    <div
      className={`
        relative
        flex flex-col
        items-center
        justify-between
        w-full ${isCareerPage ? 'max-w-[220px] h-[283px] tabletH:min-w-[368.87px] tabletH:max-w-[765px] tabletH:h-[480px]' : 'max-w-[300px] h-[219.875px] tabletH:min-w-[368.87px] tabletH:max-w-[765px] tabletH:h-[520px]'}
        rounded-[15px] p-4 tabletH:p-[30px] border
        cursor-pointer
        overflow-hidden
        hover:shadow-popup-01
        ${
          resumeData.standard
            ? 'bg-green-light01 border-green-light03'
            : 'bg-grayscale-gray00 border-grayscale-gray02'
        }
      `}
      onClick={(e) => {
        if (isOptionListOpen) {
          e.stopPropagation();
          setIsOptionListOpen(false);
          return;
        }
        onClick();
      }}
    >
      <div className='flex flex-col items-start flex-1 w-full'>
        {$isMobile ? (
          resumeData.standard && (
            <div className='absolute top-4 left-4 z-20 inline-block px-1.5 py-0.5 rounded-md bg-green-light03 text-green-deep05 typo-b11Strong'>
              Standard
            </div>
          )
        ) : (
          <div
            className={`inline-block px-1.5 py-0.5 rounded-md bg-green-light03 text-green-deep05 typo-b12Strong ${
              resumeData.standard ? 'opacity-100' : 'opacity-0'
            }`}
          >
            Standard
          </div>
        )}

        <div className='py-3 tabletH:h-[320px] w-full flex items-start justify-center tabletH:p-0'>
          <div
            className={`relative ${isCareerPage ? 'w-[99.7px] h-[141.34px] tabletH:w-[210px] tabletH:h-[268px]' : 'w-[54px] h-[76.6px] tabletH:w-[210px] tabletH:h-[268px]'} flex items-center pb-2 tabletH:p-0`}
          >
            <div
              className='absolute bottom-[4%] inset-0 z-0 border border-grayscale-gray01 bg-grayscale-gray00'
              style={{
                transform: 'rotate(6deg)',
                transformOrigin: 'bottom left',
                boxShadow:
                  '0px 3px 4px rgba(23,20,16,0.08), 0px 4px 12px rgba(23,20,16,0.16)',
              }}
            />

            <div
              className={`relative ${isCareerPage ? 'w-[99.7px] h-[141.34px] tabletH:w-[190px] tabletH:h-[260px]' : 'w-[54px] h-[76.6px] tabletH:w-[190px] tabletH:h-[260px]'} shadow-2`}
            >
              <div className='overflow-hidden w-full h-full'>
                <div
                  style={{
                    transform: isCareerPage
                      ? $isMobile
                        ? 'scale(0.29)'
                        : 'scale(0.55)'
                      : $isMobile
                        ? 'scale(0.154)'
                        : 'scale(0.55)',
                    transformOrigin: 'top left',
                    width: '697px',
                    height: '550px',
                  }}
                >
                  <PreviewContent resumeData={resumeData} currentPage={1} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='z-10 flex flex-col w-full'>
        <div
          className='typo-b14 tabletH:typo-b20Strong text-text-primary pb-0.5 tabletH:pb-2 line-clamp-2'
          style={{
            maxHeight: '2.8em',
            lineHeight: '1.4',
          }}
        >
          {resumeData.title}
          {roles.length > 0 && <span> – {roles.join(', ')}</span>}
        </div>

        <div className='flex flex-row items-center justify-between w-full gap-2'>
          <div className='flex flex-col tabletH:flex-row items-start tabletH:items-center gap-2'>
            <div className='typo-b12Strong tabletH:typo-b16Strong text-text-secondary tabletH:text-text-primary'>
              {resumeData.score}% complete
            </div>
            <div className='typo-b11 tabletH:typo-b14 text-grayscale-gray04'>
              {formatDateToShortDot(resumeData.createdAt)}
            </div>
          </div>

          <div ref={optionBtnRef}>
            <button
              className='text-text-secondary hover:text-text-primary active:text-text-primary h-[26px] w-[26px] tabletH:h-[30px] tabletH:w-[30px] flex items-end justify-end'
              onClick={toggleOptionList}
            >
              {$isMobile ? <MobileOptionIcon /> : <OptionIcon />}
            </button>
          </div>
        </div>
      </div>
      {isOptionListOpen && optionBtnRef.current && (
        <ResumeCardOptionList
          anchorRect={optionBtnRef.current.getBoundingClientRect()}
          resumeData={resumeData}
          onDeleted={onDeleted}
          onClose={() => setIsOptionListOpen(false)}
          onStandardSuccess={onStandardSuccess}
          onDeleteSuccess={onDeleteSuccess}
          isAllPage
        />
      )}
    </div>
  );
};

export default ResumeCard;
